import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HelperService } from './../../../../_shared/services/helper.service';
import { HttpClientService } from './../../../../_shared/services/http-client.service';
import { GdprCustomerConsentsData } from './../marketing/gdpr-consents/_model/gdpr-customer-consents';
import { PromotionData } from './../marketing/web-coupons/_model/promotionData.model';

@Injectable({
    providedIn: 'root',
})
export class MarketingService {
    constructor(
        private httpClient: HttpClientService,
        private helper: HelperService,
    ) {}

    public getAllPromotions(contractorId: number): Observable<PromotionData[]> {
        return this.httpClient.get(this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions`);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getPromotion(contractorId: number, promotionId: number): Observable<any> {
        return this.httpClient.get(this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions/${promotionId}`);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public createPromotion(contractorId: number, promotionData: PromotionData): Observable<any> {
        return this.httpClient.post(this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions`, promotionData);
    }
    public editPromotion(contractorId: number, promotionId: number, promotionData: PromotionData) {
        return this.httpClient.put(this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions/${promotionId}`, promotionData);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getCouponsForPromotion(contractorId: number, promotionId: number): Observable<any> {
        return this.httpClient.get(this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions/${promotionId}/coupons`);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getContacts(contractorId: number): Observable<any> {
        return this.httpClient.get(this.helper.getContactApiUrl() + `/contractors/${contractorId}/contactgroups`);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public generateCouponCodesAmount(contractorId: number, promotionId: number, amount: number): Observable<any> {
        return this.httpClient.post(
            this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions/${promotionId}/coupons/codes/${amount}`,
            {},
        );
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
    public generateContactPromotionCoupons(contractorId: number, promotionId: number, data: Object | { contactIds: [] }): Observable<any> {
        return this.httpClient.post(this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions/${promotionId}/coupons/contacts`, data);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public editCouponStatus(contractorId: number, promotionId: number, couponId: any, status: boolean) {
        return this.httpClient.put(
            this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions/${promotionId}/coupons/${couponId}/status/${status}`,
            {},
        );
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getRecipientsForPromotion(contractorId: number, promotionId: number): Observable<any> {
        return this.httpClient.get(this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions/${promotionId}/recipients`);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getConsumersForPromotion(contractorId: number, promotionId: number): Observable<any> {
        return this.httpClient.get(this.helper.getPromApiUrl() + `contractors/${contractorId}/promotions/${promotionId}/consumers`);
    }

    public getGdprConsents(contractorId: number): Observable<GdprCustomerConsentsData[]> {
        return this.httpClient.get(this.helper.getApiUrl(2) + `/contractors/${contractorId}/consentCustomers`);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public exportGdprConsents(contractorId: number, customerIds: number[]): Observable<any> {
        return this.httpClient.getAttachmentPost(this.helper.getApiUrl(2) + `/contractors/${contractorId}/customerContactsExcel`, {
            customerIds: customerIds,
        });
    }
    public manageDocumentStats(contractorId, customerIds, fileName: string): void {
        this.exportGdprConsents(contractorId, customerIds)
            .pipe(
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                map((res: any) => {
                    if (res.type !== 0) {
                        return new Blob([res.body], { type: _.get(res, 'body.type', '') });
                    }
                }),
            )
            .subscribe(
                res => {
                    if (res) {
                        let fileNameLocal: string = fileName;
                        if (res.type === 'text/csv') {
                            fileNameLocal += '.csv';
                        }
                        FileSaver.saveAs(res, fileNameLocal);
                    }
                },
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
                err => {},
            );
    }
}
